import api from './api';

export interface LinhaSla {
  id: string;
  item: string;
  descricao: string;
  conceito: string;
  penalt: number;
  percentual: number;
  bonus: number;
  usuarioPodeAlterarDados: boolean;
  medicaoOriginalNumero: number;

  bonusString: string;
  penaltString: string;
  slaAtual: boolean;
  contemComentario: boolean;
}

export interface Comentario {
  id: string;
  mensagem: string;
  mrn: boolean;
  nomeDoUsuario: string;
  nomeDoArquivo: string;
  possuiArquivo: boolean;
  dataHoraInclusao: string;
}

export const GetLinhaAtual = (medicaoId: string) => api.get<LinhaSla>(`sla/GetLinhaAtual/${medicaoId}`);
export const GetLinhasInjetadas = (medicaoId: string) =>
  api.get<Array<LinhaSla>>(`sla/GetLinhasInjetadas/${medicaoId}`);
export const UpdateLinhaAtual = (values: any) => api.post(`sla/UpdateLinhaAtual`, values);
export const EscalarSla = (dados: any) => api.post('sla/EscalarSla', dados);
export const ConfirmarSla = (values: any) => api.post(`sla/ConfirmarSla`, values);
export const RefutarSlaFornecedor = (data: any) => api.post(`sla/RefutarSlaFornecedor`, data);
export const ConfirmarSlaFornecedor = (medicaoId: string) => api.post(`sla/ConfirmarSlaFornecedor/${medicaoId}`);
export const ConfirmarSlaGestorFornecedor = (medicaoId: string) =>
  api.post(`sla/ConfirmarSlaGestorFornecedor/${medicaoId}`);
export const RefutarSlaGestorFornecedor = (data: any) => api.post(`sla/RefutarSlaGestorFornecedor`, data);
export const ConfirmarAnaliseJustificativaSla = (medicaoId: string) =>
  api.post(`sla/ConfirmarAnaliseJustificativaSla/${medicaoId}`);
export const DiscordarAnaliseJustificativaSla = (medicaoId: string) =>
  api.post(`sla/DiscordarAnaliseJustificativaSla/${medicaoId}`);
export const PostergarAnaliseJustificativaSla = (medicaoId: string) =>
  api.post(`sla/PostergarAnaliseJustificativaSla/${medicaoId}`);
export const ForcarValorSla = (medicaoId: string) => api.post(`sla/ForcarValorSla/${medicaoId}`);
export const SolicitacaoParaConluirSla = (values: any) => api.post(`sla/SolicitarConclusaoSla`, values);
export const EfetuarConclusaoSla = (medicaoId: string) => api.post(`sla/EfetuarConclusaoSla/${medicaoId}`);
export const ResolverPendenciaSla = (medicaoId: string) => api.post(`sla/ResolverPendenciaSla/${medicaoId}`);
export const ReprovarSlaGestor = (medicaoId: string) => api.post(`sla/ReprovarSlaGestor/${medicaoId}`);
export const AprovarSlaGestor = (medicaoId: string) => api.post(`sla/AprovarSlaGestor/${medicaoId}`);
export const SalvarComentarioLinhaSla = (form: any) => api.post(`sla/SalvarComentarioLinhaSla`, form);
export const ObterComentarioPorLinhaSlaId = (id: any) =>
  api.get<Comentario[]>(`sla/ObterComentarioPorLinhaSlaId/${id}`);
